<template>
<div>
  <div class="row">
    <div class="col-md-8">
      <div class="box-header">
        <h3 class="box-title title" style="color:#959FA9">Inventario </h3>
        <h3 class="box-title title" style=""><span class="table-btn-icon"></span> {{ 'ERI ' + this.accountName + ' - ' + this.periodStr}}</h3>
      </div>
      </div>
      <div class="col-md-4">
        <button class="btn btn-success pull-right exportar" @click="exportData">Exportar <img src="/static/img/arrow-logo.png"></button>
      <router-link :to="{name: 'InventoryEntry', params: {accountCode: this.$route.params.accountCode}}" tag="button" class="btn btn-success pull-right" style="margin-right:10px">Registrar ERI</router-link>
    </div>
  </div>

  <div class="box box-success">
    <div class="box-body">
      <div class="row">
        <div class="col-md-12">
          <v-eri id="eriCyclical" title="ERI Cíclico" unit="Cant" :period="this.period" :data="this.eriCyclicalData"></v-eri>
        </div>
      </div>
    </div>
  </div>
  <div class="box box-success">
       <div class="box-body">
        <div class="row">
          <div class="col-md-12">
            <v-eri id="eriLocation" title="ERI Ubicaciones" unit="Ubicaciones" :period="this.period" :data="this.eriLocationData"></v-eri>
          </div>
        </div>
      </div>
    </div>
      
      <div class="box box-success">
        <div class="box-body">
        <div class="row">
          <div class="col-md-12">
            <v-eri id="eriUnit" title="ERI Unidades" unit="Unidades" :period="this.period" :data="this.eriUnitData"></v-eri>
          </div>
        </div>
      </div>
      </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EriDetail from './EriDetail'
import moment from 'moment/moment.js'

export default {
  name: 'InventoryDetail',
  data () {
    return {
      loader: null,
      period: '',
      periodStr: '',
      accountCode: '',
      accountName: '',
      eriCyclicalData: null,
      eriLocationData: null,
      eriUnitData: null
    }
  },
  created () {
    this.period = this.$route.params.period
    this.periodStr = this.$options.filters.formatFirstLetter(moment(this.period.substr(4, 2), 'MM').format('MMMM')) + ' ' + this.period.substr(0, 4)

    let code = this.$route.params.accountCode

    let found = this.userClients.find(function (item) {
      return item.code === code
    })

    if (found) {
      this.accountCode = found.code
      this.accountName = found.name
    }

    this.loadData()
  },
  components: {
    'v-eri': EriDetail
  },
  computed: {
    ...mapGetters([
      'userClients'
    ])
  },
  methods: {
    ...mapActions([
      'fetchEriDetailData',
      'exportEriDetailData'
    ]),
    loadData () {
      let params = {
        accountCode: this.accountCode,
        period: this.period
      }

      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.fetchEriDetailData(params)
      .then((data) => {
        if (data != null) {
          this.eriCyclicalData = data.cyclicalValues
          this.eriLocationData = data.locationValues
          this.eriUnitData = data.unitValues
          this.loader.hide()
        }
      })
    },
    exportData () {
      document.activeElement.blur()

      let params = {
        accountCode: this.accountCode,
        period: this.period
      }

      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.exportEriDetailData(params)
      .then((data) => {
        let fileName = 'ERI' + '_' + this.accountName + '_' + this.period + '.xlsx'
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        this.loader.hide()
      })
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>

.exportar{
  background: none!important;
  border-color: black;
  color: black;
}

.exportar{
  background: none!important;
  border-color: black;
  color: black;
}

.exportar:hover{
    border-radius: 4px 4px 4px 4px;
  	background-color: #3A4460 !important;
    color: white;
}


</style>



// WEBPACK FOOTER //
// InventoryDetail.vue?2da0e394